import Component from '@glimmer/component';

interface SearchPageFilterPlannedListComponentArgs {
  current: string | undefined;
}

export default class SearchPageFilterPlannedListComponent extends Component<SearchPageFilterPlannedListComponentArgs> {
  get planned() {
    if (this.args.current === 'true') {
      return 'planned';
    } else if (this.args.current === 'false') {
      return 'unplanned';
    }
    return 'all';
  }
}
